import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/Example.svg?component
var Example_exports = /* @__PURE__ */ __exportAll({
	default: () => Example_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "m18.59 15.3 2.9-2.91a1.32 1.32 0 0 0 0-1.87l-1.85-1.85a3.3 3.3 0 1 1-4.31-4.31L13.48 2.5a1.32 1.32 0 0 0-1.87 0l-2.9 2.91a3.3 3.3 0 1 0-3.3 3.3l-2.9 2.9a1.32 1.32 0 0 0 0 1.87l1.85 1.85a3.3 3.3 0 1 1 4.31 4.31l1.85 1.85a1.32 1.32 0 0 0 1.87 0l2.9-2.9a3.3 3.3 0 1 0 3.3-3.3Z"
	}, null, -1)])]);
}
var Example_default = { render: render$1 };
//#endregion
export { Example_exports, Example_default as default, render$1 as render };

//# sourceMappingURL=Example.svg.virtual.js.map